import { createAction, props } from '@ngrx/store';
import { Sucursal } from './sucursales.model';

export const cambiarSucursal = createAction(
  '[Sucs] Cambiando de Sucursal',
  props<{ obj: Partial<Sucursal> }>()
);

export type AccionesValidas = typeof cambiarSucursal;
